import apiClient from 'apiClient';
import { AxiosResponse } from 'axios';
import { PepperValidationError } from 'modules/cm/pages/CaseDetailsPage/Pepper/errors';
import { isPepperValidationError } from './errors';
import { ValidationError } from './errors/ValidationError';

type ValidateDataResponse = AxiosResponse;

const validateFunc = (caseId: string) => {
  return apiClient.post<any, ValidateDataResponse>(`/api/v1/cases/${caseId}/validate-pepper`).catch((e) => {
    if (isPepperValidationError(e)) {
      throw new PepperValidationError((e.response as AxiosResponse<ValidationError>).data);
    }
    throw e;
  });
};
export default validateFunc;
